import debounce from 'lodash/debounce';
import DetectIE from '../utils/detect-ie';
const isIE = DetectIE();
export default {
  name: 'viewport',

  getReducer(){
    const initialState = {
      h: window.innerHeight,
      w: window.innerWidth,
      isIE
    }

    return (state = initialState, { type, payload }) => {

      if(type === 'WINDOW_RESIZE'){
        return Object.assign({}, state, {
          h: window.innerHeight,
          w: window.innerWidth
        })
      }

      return state;
    }
  },

  doHandleResize: () => ({dispatch, store}) => {    
    dispatch({type:'WINDOW_RESIZE'});
    const map = store.selectMap();
    map.updateSize()
  },

  selectViewportHeight: (state) => {
    return state.viewport.h;
  },
  selectViewportIsIE: (state) => {
    return state.viewport.isIE;
  },

  init: (store) => {
    window.addEventListener('resize', debounce(store.doHandleResize, 300));
  }
}